/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import styled from '@emotion/styled';
import { convertToBgImage } from 'gbimage-bridge';
import BackgroundImage from 'gatsby-background-image';

export const StyledFullScreenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  border: 0px solid red;
  min-height: 450px;
  margin: 0;
`;

const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: nowrap;
  border: 0px solid #aaa;
  padding: 10px;
`;

const BackgroundSection = ({
  className,
  image,
  minWidth = ['100%', '50%'],
  minHeight = '450px',
  backgroundSize = 'cover',
  backgroundPosition = 'center, center',
  children,
}) => {
  const bgImage = convertToBgImage(image);

  return (
    <StyledFullScreenWrapper sx={{ minHeight }}>
      <StyledTextWrapper sx={{ minWidth, width: '100%' }}>
        {children}
      </StyledTextWrapper>
      <BackgroundImage
        Tag="section"
        role="img"
        id="hero-image"
        className={className}
        aria-label="hero-image"
        {...bgImage}
        loading="eager"
        title=""
        style={{
          backgroundSize,
          backgroundPosition,
        }}
        fadeIn="soft"
      />
    </StyledFullScreenWrapper>
  );
};

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100vw;
`;

export default StyledBackgroundSection;
